"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _utils = require("@seedlang/utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var CommentIndexWrapper = function CommentIndexWrapper(Component) {
  var _class, _class2, _descriptor, _descriptor2, _descriptor3;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2(props) {
      var _this$props$commentab;
      var _this;
      _classCallCheck(this, _class2);
      _this = _callSuper(this, _class2, [props]);
      _initializerDefineProperty(_this, "showSpinner", _descriptor, _this);
      _initializerDefineProperty(_this, "loadFailed", _descriptor2, _this);
      _initializerDefineProperty(_this, "targetCommentFound", _descriptor3, _this);
      _this.setCommentOrdering = function (ordering) {
        _state.AppUI.user.set('commentOrdering', ordering);
        _state.AppUI.authUserStore.update({
          data: {
            comment_ordering: ordering
          }
        }, _this.afterCommentOrdering);
      };
      _this.onUpdateForumThread = function () {
        _state.ForumUI.loadForumThread(_this.props.forumThreadId);
      };
      _this.getComments = function () {
        var _AppUI$commentStore$i, _AppUI$commentStore$i2, _AppUI$commentStore$i3;
        var forceReload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var forumThreadId = _this.effectiveForumThreadId;
        var feedEntryId = _this.props.feedEntryId || (_this.props.commentableType === 'FeedEntry' ? _this.props.commentableId : null);
        var commentableType = _this.props.commentableType;
        var ids = {
          commentableType: commentableType,
          forumThreadId: forumThreadId,
          feedEntryId: feedEntryId
        };
        if (forceReload || !_state.AppUI.commentStore.hasIndexData || ((_AppUI$commentStore$i = _state.AppUI.commentStore.ids) === null || _AppUI$commentStore$i === void 0 ? void 0 : _AppUI$commentStore$i.commentableType) !== commentableType || ((_AppUI$commentStore$i2 = _state.AppUI.commentStore.ids) === null || _AppUI$commentStore$i2 === void 0 ? void 0 : _AppUI$commentStore$i2.forumThreadId) !== forumThreadId || ((_AppUI$commentStore$i3 = _state.AppUI.commentStore.ids) === null || _AppUI$commentStore$i3 === void 0 ? void 0 : _AppUI$commentStore$i3.feedEntryId) !== feedEntryId) {
          _this.showSpinner = true;
          _this.loadFailed = false;
          _state.AppUI.commentStore.setPage(1);
          _state.AppUI.commentStore.clearIndexData();
          _state.ForumUI.onReset();
          var queryStrings = {
            commentable_type: commentableType
          };
          if (feedEntryId) {
            queryStrings.feed_entry_id = feedEntryId;
          } else {
            queryStrings.forum_thread_id = forumThreadId;
          }
          // submitting replies on page 2 is not working (replies show up at the top of page 1)
          // but showing all comments is crashing some mobile devices
          // in the short term, desktop shows all, and mobile paginates but with broken replies
          // it's less of an issue on mobile because Patreon doesn't exist there
          if (!_state.AppUI.layout.isNative) {
            queryStrings['expand_forum'] = true;
          } else {
            queryStrings['comment_ordering'] = '-created_at';
            if (_this.props.targetCommentId) queryStrings.target_comment_id = _this.props.targetCommentId;
          }
          var params = {
            queryStrings: queryStrings,
            ids: ids,
            failureCallback: _this.onLoadFailed,
            onRequestError: _this.onLoadFailed
          };
          if (_state.AppUI.layout.isNative) {
            params.limit = 10;
          }
          _state.AppUI.commentStore.getIndex(params, _this.afterGetComments);
        }
      };
      _this.afterCreateComment = function () {
        _this.getComments(true);
        if (_this.props.onChange) {
          _this.props.onChange();
        }
      };
      _this.onLoadFailed = function () {
        _this.showSpinner = false;
        _this.loadFailed = true;
      };
      _this.afterGetComments = function (resp) {
        var _resp$meta, _resp$meta2;
        if ((_resp$meta = resp.meta) !== null && _resp$meta !== void 0 && _resp$meta.page) _state.AppUI.commentStore.setPage(resp.meta.page);
        _this.targetCommentFound = ((_resp$meta2 = resp.meta) === null || _resp$meta2 === void 0 ? void 0 : _resp$meta2.targetCommentFound) !== false;
        _state.AppUI.commentStore.setIndexData(resp);
        _this.showSpinner = false;
      };
      _this.afterCommentOrdering = function () {
        _this.getComments(true);
      };
      if ((0, _utils.isBlank)((_this$props$commentab = _this.props.commentable) === null || _this$props$commentab === void 0 ? void 0 : _this$props$commentab.comments)) {
        _this.getComments(Boolean(_this.props.targetCommentId));
      }
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "effectiveForumThreadId",
      get: function get() {
        if (this.props.wordId) {
          var _DeckUI$currentCard;
          var word = this.props.word || (((_DeckUI$currentCard = _state.DeckUI.currentCard) === null || _DeckUI$currentCard === void 0 || (_DeckUI$currentCard = _DeckUI$currentCard.word) === null || _DeckUI$currentCard === void 0 ? void 0 : _DeckUI$currentCard.id) === this.props.wordId ? _state.DeckUI.currentCard.word : null) || (_state.AppUI.wordStore.hasShowData && _state.AppUI.wordStore.showData.id === this.props.wordId ? _state.AppUI.wordStore.showData : null);
          if (word && word.forumThreadId) {
            return word.forumThreadId;
          }
        }
        if (this.props.sentenceId) {
          var _DeckUI$currentCard2;
          var sentence = this.props.sentence || (((_DeckUI$currentCard2 = _state.DeckUI.currentCard) === null || _DeckUI$currentCard2 === void 0 || (_DeckUI$currentCard2 = _DeckUI$currentCard2.sentence) === null || _DeckUI$currentCard2 === void 0 ? void 0 : _DeckUI$currentCard2.id) === this.props.sentenceId ? _state.DeckUI.currentCard.sentence : null) || (_state.AppUI.sentenceStore.hasShowData && _state.AppUI.sentenceStore.showData.id === this.props.sentenceId ? _state.AppUI.sentenceStore.showData : null);
          if (sentence && sentence.forumThreadId) {
            return sentence.forumThreadId;
          }
        }
        return this.props.forumThreadId || _state.ForumUI.forumThreadId;
      }
    }, {
      key: "comments",
      get: function get() {
        return this.props.commentable && !(0, _utils.isBlank)(this.props.commentable.comments) ? this.props.commentable.comments : _state.AppUI.commentStore.indexData;
      }
    }, {
      key: "latestCommentId",
      get: function get() {
        if (this.comments.length === 0) {
          return null;
        }
        var sortedComments = _toConsumableArray(this.comments).sort(function (a, b) {
          var _a$createdAt, _b$createdAt;
          var aDate = (_a$createdAt = a.createdAt) === null || _a$createdAt === void 0 ? void 0 : _a$createdAt.dateObj;
          var bDate = (_b$createdAt = b.createdAt) === null || _b$createdAt === void 0 ? void 0 : _b$createdAt.dateObj;
          return bDate - aDate;
        });
        return sortedComments[0].id;
      }
    }, {
      key: "compactCommentLayout",
      get: function get() {
        return Boolean(this.props.compactCommentLayout || this.props.inDeckComments || _state.AppUI.layout.isMobile);
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          showSpinner: this.showSpinner,
          loadFailed: this.loadFailed,
          targetCommentFound: this.targetCommentFound,
          comments: this.comments,
          setCommentOrdering: this.setCommentOrdering,
          afterCommentOrdering: this.afterCommentOrdering,
          store: _state.AppUI.commentStore,
          onChange: this.afterCreateComment,
          onUpdateForumThread: this.onUpdateForumThread,
          latestCommentId: this.latestCommentId,
          compactCommentLayout: this.compactCommentLayout
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "showSpinner", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "loadFailed", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "targetCommentFound", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return true;
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "effectiveForumThreadId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "effectiveForumThreadId"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "comments", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "comments"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "latestCommentId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "latestCommentId"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "compactCommentLayout", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "compactCommentLayout"), _class2.prototype), _class2)) || _class;
};
CommentIndexWrapper.displayName = 'CommentIndexWrapper';
var _default = exports["default"] = CommentIndexWrapper;